import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {GlobalFunction} from '../../core/global_function';

@Component({
    selector: 'filtersearch',
    templateUrl: 'filtersearch.component.html',
    styleUrls: []
})

export class FiltersearchComponent implements OnInit {

    @Output()
    selectFilterChanged = new EventEmitter<any>();

    private _classfilter: any;
    @Input()
    set classfilter(value) {
        this._classfilter = value;
    }
    get classfilter() {
        return this._classfilter;
    }

    private _columns: any;
    private _columns_obj: any;
    @Input()
    set columns(value) {
        var data = [];
        for (var item of value) {
            var item_new = Object.assign({}, item);
            item_new.value = '';
            /*if (item.attribute == 'academic_year') {
              item_new.value = item_new.listData[Object.keys(item_new.listData)[0]];
            }*/
            if (item.selectOptions) {
                item_new.listData = item.selectOptions;
            } else if (item.listData) {
                var listData = [{ value: '', label: 'All' }];
                for (var k in item.listData) {
                    if(item.type === 'boolean'){
                      let key = '';
                      key = (k=='0') ? 'false' : 'true';
                      listData.push({ value: key, label: item.listData[k] });
                    }else{
                      listData.push({ value: k, label: item.listData[k] });
                    }
                }
                item_new.listData = listData;
            }
          data.push(item_new);
        }
        this._columns = data;
        this._columns_obj = GlobalFunction.index(this._columns, 'attribute');
        this.sub = this.route.params.subscribe(params => {
          for (var it in params) {
            if (this._columns_obj[it]) {
              this._columns_obj[it].value = params[it];
            }
          }
        });
    }

    get columns() {
        return this._columns;
    }


    constructor(private route: ActivatedRoute, private router: Router) { }

    sub: any;
    ngOnInit() {
    }

    onSubmit() {
        var a = this.route.snapshot['_routerState'].url.split(';');
        var link = a[0];
        var params = {};
        for (var item of this._columns) {
          if (item.attribute == 'academic_year') {
            params[item.attribute] = '';
          }
            if (item.value !== '' && item.value !== undefined) {
                params[item.attribute] = item.value;
            }
        }
        this.router.navigate([link, params]);
    }

    changeValue(column) {
      this.selectFilterChanged.emit(column);
    }
}



// WEBPACK FOOTER //
// ./src/app/common/component/filtersearch/filtersearch.component.ts